<template>
  <div>
    <div v-if="mode === 'DESIGN'">
      <el-select class="max-fill" size="medium" v-model="_value" disabled
        :placeholder="placeholder" />
    </div>
    <div v-else-if="mode === 'PC' && !readonly">
      <el-select class="max-fill" v-model="_value" value-key="id" size="medium" clearable :placeholder="placeholder">
        <el-option v-for="(op, index) in options" :key="index" :value="op" :label="op.systemName"></el-option>
      </el-select>
    </div>
    <div v-else-if="mode === 'MOBILE' && !readonly">
      <el-select class="max-fill" v-model="_value" size="medium" clearable :placeholder="placeholder">
        <el-option v-for="(op, index) in options" :key="index" :value="op" :label="op.systemName"></el-option>
      </el-select>
    </div>
    <div v-else>
      {{ _value.systemName }}
    </div>
  </div>
</template>

<script>
import { Field, Popup, Picker, Radio, RadioGroup } from 'vant';
import componentMinxins from '../ComponentMinxins'

export default {
  mixins: [componentMinxins],
  name: "SystemTypeInput",
  components: { Radio, RadioGroup, Picker, Field, Popup },
  props: {
    value: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: '请选择选项'
    },
    options: {
      type: Array,
      default: () => {
        return []
      }
    },
    propValue: {
      type: Object,
      default: () => {
        return {}
      }
    },
    formData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showPicker: false,
    }
  },
  created() {
    setTimeout(() => {
        this.options = this.propValue.options
        this._value = this.value
        this.$forceUpdate();
      }, 600)
  },
  methods: {
    onConfirm(val) {
      this.showPicker = false
      this._value = val
    }
  }
}
</script>

<style scoped></style>
